<div class="stepper-wrapper">

  <ng-container *ngFor="let item of steps;index as i">
     <div class="stepper-item" [ngClass]="{'completed': (i+ 1 < active), 'active': (i+ 1 == active) ,'' : (i+ 1 > active)}">
       <div class="step-counter"></div>
       <div class="step-name">{{ item}}</div>
   </div>
   </ng-container>

 </div>
